/**
 * Owner: Masa Bayu
 * File: MarketplaceDetailAuth.tsx
 * Date:Time: 2026-10-22 10:58
 * Description: MarketplaceDetail §377 — borang auth inline, dipindah verbatim dari
 *   MarketplaceDetail.tsx; state kekal di ibu, DOM sama.
 *   §457 F5 — overlay ini jadi LOG MASUK SAHAJA: pendaftaran qxread berlaku pada
 *   SATU borang (`/login`, dengan pilihan Reader/Publisher), jadi tiada lagi
 *   borang daftar kedua di dalam halaman produk.
 */

import type { FormEvent, ReactElement } from 'react';
import type { MarketplaceLabels } from './marketplace-locale';

export interface MarketplaceDetailAuthProps {
  readonly t: MarketplaceLabels;
  readonly authEmail: string;
  readonly authPassword: string;
  readonly authError: string | null;
  readonly authBusy: boolean;
  readonly onEmailChange: (value: string) => void;
  readonly onPasswordChange: (value: string) => void;
  readonly onClose: () => void;
  readonly onSubmit: () => void;
  readonly onCreateAccount: () => void;
}

export function MarketplaceDetailAuth({
  t,
  authEmail,
  authPassword,
  authError,
  authBusy,
  onEmailChange,
  onPasswordChange,
  onClose,
  onSubmit,
  onCreateAccount,
}: MarketplaceDetailAuthProps): ReactElement {
  return (
    <div className="hmk__auth-overlay" role="presentation" onClick={onClose}>
      <div
        className="hmk__auth-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="hmk-auth-title"
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <button
          type="button"
          className="hmk__auth-close"
          aria-label={t.auth.close}
          onClick={onClose}
        >
          ×
        </button>
        <h2 id="hmk-auth-title" className="hmk__auth-title">
          {t.auth.titleLogin}
        </h2>
        <p className="hmk__auth-sub">{t.auth.subtitle}</p>
        <form
          className="hmk__auth-form"
          onSubmit={(event: FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            onSubmit();
          }}
        >
          <label className="hmk__auth-field">
            <span>{t.auth.emailLabel}</span>
            <input
              type="email"
              required
              autoComplete="email"
              placeholder={t.auth.emailPlaceholder}
              value={authEmail}
              onChange={(event) => {
                onEmailChange(event.target.value);
              }}
            />
          </label>
          <label className="hmk__auth-field">
            <span>{t.auth.passwordLabel}</span>
            <input
              type="password"
              required
              minLength={8}
              autoComplete="current-password"
              placeholder={t.auth.passwordPlaceholder}
              value={authPassword}
              onChange={(event) => {
                onPasswordChange(event.target.value);
              }}
            />
          </label>
          {authError !== null ? (
            <p className="hmk__auth-error" role="alert">
              {authError}
            </p>
          ) : null}
          <button type="submit" className="hmk__buy-btn" disabled={authBusy}>
            {authBusy ? t.auth.busy : t.auth.submitLogin}
          </button>
        </form>
        <button type="button" className="hmk__auth-switch" onClick={onCreateAccount}>
          {t.auth.goCreateAccount}
        </button>
      </div>
    </div>
  );
}
